import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { forwardRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';


const ClientAreaOne = forwardRef(({ data, questions, carMakes }, ref) => {
  const [loading, setLoading] = useState(false);
  const [carDetailsAvailable, setCarDetailsAvailable] = useState("Yes");
  const [selectedMake, setSelectedMake] = useState(""); // Track selected make
  const [carYears, setCarYears] = useState([]); // Store car years from API
  const [selectedYear, setSelectedYear] = useState(""); // Track selected year
  const [carModels, setCarModels] = useState([]); // Store car models from API
  const [selectedModel, setSelectedModel] = useState(""); // Track selected model
  const [isYearLoading, setIsYearLoading] = useState(false); // Track year loading state
  const [isModelLoading, setIsModelLoading] = useState(false); // Track model loading state
  const navigate = useNavigate();

  useEffect(() => {
    if (carDetailsAvailable === "Yes") {
      setSelectedMake("");
      setSelectedYear("");
      setSelectedModel("");
      setCarYears([]);
      setCarModels([]);
    }
  }, [carDetailsAvailable]);
  useEffect(() => {
    if (!selectedMake) {
      setCarYears([]);
      return;
    }

    const fetchCarYears = async () => {
      setIsYearLoading(true); // Show loader while fetching years
      try {
        const response = await fetch(
          `https://cms.roadrunnertowingmi.com/data/get-years?id=${selectedMake}`
        );
        const result = await response.json();

        if (response.status === 200) {
          setCarYears(result.years); // Assuming API returns an array of years
        } else {
          toast.error("Failed to fetch car years.");
          setCarYears([]);
        }
      } catch (error) {
        console.error("Error fetching car years:", error);
        setCarYears([]);
      } finally {
        setIsYearLoading(false); // Hide loader after API call completes
      }
    };

    fetchCarYears();
  }, [selectedMake]);

  useEffect(() => {
    if (!selectedMake || !selectedYear) {
      setCarModels([]);
      setSelectedModel("");
      return;
    }
    const fetchCarModels = async () => {
      setIsModelLoading(true); // Show loader while fetching models
      try {
        const response = await fetch(
          `https://cms.roadrunnertowingmi.com/data/get-models?make_id=${selectedMake}&year_id=${selectedYear}`
        );
        const result = await response.json();

        if (response.status === 200) {
          setCarModels(result.models); // Assuming API returns an array of models
        } else {
          toast.error("Failed to fetch car models.");
          setCarModels([]);
        }
      } catch (error) {
        console.error("Error fetching car models:", error);
        setCarModels([]);
      } finally {
        setIsModelLoading(false); // Hide loader after API call completes
      }
    };

    fetchCarModels();
  }, [selectedMake, selectedYear]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = {};
    setLoading(true);
    formData.forEach((value, key) => {
      if (data[key]) {
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });
    try {
      const response = await fetch(
        "https://cms.roadrunnertowingmi.com/data/submit-quote",
        {
          method: "POST",
          body: formData,
        }
      );
      const result = await response.json();
      if (response.status === 200 && result.succeeded) {
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-16939224614/YwS1CMXT4KwaEKacoI0_',
            value: 1.0,
            currency: 'PKR',
          });
        }
        toast.success("Quote has been successfully sent!");
        navigate('/thank-you');
        form.reset();
        setSelectedMake("");
        setSelectedYear("");
        setSelectedModel("");
        setCarYears([]);
        setCarModels([]);
      } else if (response.status === 500 || !result.succeeded) {
        toast.error(
          result.message || "An error occurred while submitting the form."
        );
      } else {
        toast.error(`Unexpected error: ${response.status}`);
      }
    } catch (error) {
      alert({ type: "error", text: `Form Submission Error: ${error.message}` });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      className="client-bg-area space-top style mt-4"
      style={{ backgroundImage: "url(assets/img/bg/client-bg1-1.png)" }}
    >
      {/*==============================
    Appointment Area  
    ==============================*/}
      <div className="appointment-area-1 overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="appointment-form-wrap bg-theme">
                <div className="title-area">
                  <span className="sub-title text-white">{data?.title} </span>
                  <h2 className="sec-text text-white">{data?.subtitle}</h2>
                </div>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  {questions.map((section) => (
                    <div key={section.id} className="section">
                      <h3 style={{ textAlign: "center" }}>{section.section}</h3>
                      <div className="row">
                        {/* Car Details Section */}
                        {section.section === "Car Details" && (
                          <>
                            {/* Car Availability Question */}
                            <div className="col-md-12">
                              <div className="form-group">
                                <label className="form-label">
                                  <b>
                                    If you can’t find your car in the list below, select 'No' to enter the make, model, and year manually.
                                  </b>{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <div className="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="car-details-available-yes"
                                      name="car_details_available"
                                      value="Yes"
                                      checked={carDetailsAvailable === "Yes"}
                                      onChange={(e) =>
                                        setCarDetailsAvailable(e.target.value)
                                      }
                                      required
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="car-details-available-yes"
                                    >
                                      <b>Yes</b>
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="car-details-available-no"
                                      name="car_details_available"
                                      value="No"
                                      checked={carDetailsAvailable === "No"}
                                      onChange={(e) =>
                                        setCarDetailsAvailable(e.target.value)
                                      }
                                      required
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="car-details-available-no"
                                    >
                                      <b>No</b>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* If Yes, Show Select Dropdown */}
                            {carDetailsAvailable === "Yes" && (
                              <>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="form-label">
                                      <b>Select Car Make</b>
                                    </label>
                                    <select
                                      className="form-control style-border2"
                                      name="car_make"
                                      value={selectedMake}
                                      onChange={(e) =>
                                        setSelectedMake(e.target.value)
                                      }
                                      required
                                    >
                                      <option value="">Select a make</option>
                                      {carMakes.map((make) => (
                                        <option key={make.id} value={make.id}>
                                          {make.make}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>

                                {/* Year Dropdown (Fetched from API based on Make Selection) */}
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="form-label">
                                      <b>Select Year</b>
                                    </label>
                                    <select
                                      className="form-control style-border2"
                                      name="car_year"
                                      value={selectedYear}
                                      onChange={(e) =>
                                        setSelectedYear(e.target.value)
                                      }
                                      required
                                      disabled={!selectedMake || isYearLoading} // Disable until years are fetched
                                    >
                                      <option value="">
                                        {isYearLoading
                                          ? "Loading years..."
                                          : "Select a year"}
                                      </option>
                                      {!isYearLoading &&
                                        carYears.map((year) => (
                                          <option key={year.id} value={year.id}>
                                            {year.year}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <label className="form-label">
                                      <b>Select Model</b>
                                    </label>
                                    <select
                                      className="form-control style-border2"
                                      name="car_model"
                                      value={selectedModel}
                                      onChange={(e) =>
                                        setSelectedModel(e.target.value)
                                      }
                                      required
                                      disabled={!selectedYear || isModelLoading} // Disable until models are fetched
                                    >
                                      <option value="">
                                        {isModelLoading
                                          ? "Loading models..."
                                          : "Select a model"}
                                      </option>
                                      {!isModelLoading &&
                                        carModels.map((model) => (
                                          <option
                                            key={model.id}
                                            value={model.id}
                                          >
                                            {model.model}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* If No, Show Text Inputs */}
                            {carDetailsAvailable === "No" && (
                              <>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="form-label">
                                      <b>Make</b>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control style-border2"
                                      name="car_make"
                                      placeholder="Enter Car Make"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="form-label">
                                      <b>Year</b>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control style-border2"
                                      name="car_year"
                                      placeholder="Enter Car Year"
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <label className="form-label">
                                      <b>Model</b>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control style-border2"
                                      name="car_model"
                                      placeholder="Enter Car Model"
                                      required
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}

                        {/* Other Questions */}
                        {section.questions.map((question) => {
                          const isFullRow = question.row === "Full Row";
                          const isHalfRow = question.row === "Half Row";
                          const isRequired = question.is_optional === 0;

                          return (
                            <div
                              key={question.id}
                              className={
                                isFullRow
                                  ? "col-md-12"
                                  : isHalfRow
                                    ? "col-md-6"
                                    : "col-md-12"
                              }
                            >
                              <div className="form-group">
                                {question.type === "Text" && (
                                  <input
                                    type="text"
                                    className="form-control style-border2"
                                    name={question.id}
                                    placeholder={question.title}
                                    required={isRequired}
                                  />
                                )}
                                {question.type === "Long Text" && (
                                  <textarea
                                    className="form-control style-border2"
                                    name={question.id}
                                    placeholder={question.title}
                                    required={isRequired}
                                  />
                                )}
                                {question.type === "Checkbox" && (
                                  <div>
                                    <label className="form-label">
                                      <b>{question.title}</b>{" "}
                                      {isRequired && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <div
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      {question.options.map((option) => (
                                        <div
                                          key={option.id}
                                          className="form-check form-check-inline"
                                        >
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            id={`option-${option.id}`}
                                            name={question.id}
                                            value={option.value}
                                            required={isRequired}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={`option-${option.id}`}
                                          >
                                            <b>{option.value}</b>
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                {question.type === "Image" && (
                                  <div>
                                    <label className="form-label">
                                      <b>{question.title}</b>{" "}
                                      {isRequired && (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                    </label>
                                    <input
                                      type="file"
                                      className="form-control-input"
                                      name={question.id + '[]'}
                                      accept="image/*"
                                      multiple={true}
                                      required={isRequired}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}

                  <button className="btn style3">
                    {loading ? "Submitting..." : data?.btn_text_1}
                    <i className="fas fa-arrow-right ms-2" />
                  </button>
                </form>

                <ToastContainer position="top-right" autoClose={3000} />
              </div>
            </div>
          </div>
        </div>
        <div className="appointment-thumb-1">
          <img src="/assets/img/bg/client-bg1-1.png" alt="Image" />
        </div>
      </div>
    </div>
  );
});

export default ClientAreaOne;
